import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

import { useCartCookie } from '@/helpers/useCartCookie';
import { getDomain } from '@/helpers/api';
import { useToken } from '@/context/useToken';

import { Button } from '@/components/ui/button';

import { useSelf } from '@/data/user';

const LogoutButton = () => {
  const user = useSelf();
  const navigate = useNavigate();
  const { setToken } = useToken();
  const { removeCartId } = useCartCookie();

  const handleLogOut = (e) => {
    e.preventDefault();
    Cookies.remove('token', { domain: getDomain() });
    removeCartId();
    setToken(null);
    user.mutate();
    navigate('/');
    window.location.reload();
  };
  return (
    <Button onClick={handleLogOut} size="sm" variant="outline">
      Log Out
    </Button>
  );
};

export default LogoutButton;
